module.exports = __webpack_public_path__ + "static/media/Building B-2-Meter_MDB-C_Area.4a8beb21.jpg";